import { useEffect } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { clearSentryUser } from '../services/sentry';

// Shared with App's ProtectedRoute definitions so expiry follows route ownership.
export const AUTH_PROTECTED_ROUTES = {
    dashboard: '/dashboard/*',
    admin: '/admin/*',
} as const;

export default function AuthExpiryPolicy({ disabled = false }: { disabled?: boolean }) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (disabled) return;
        const handleAuthExpired = () => {
            // Recovery flows own their authentication, including magic-link redemption.
            if (location.pathname === '/login' || location.pathname === '/welcome-back') return;
            clearSentryUser();
            if (window.gtag) window.gtag('set', { user_id: null });
            if (!Object.values(AUTH_PROTECTED_ROUTES).some(pattern => matchPath(pattern, location.pathname))) return;
            const returnPath = `${location.pathname}${location.search}`;
            navigate(`/login?reason=session-expired&return=${encodeURIComponent(returnPath)}`, { replace: true });
        };
        window.addEventListener('auth-expired', handleAuthExpired);
        return () => window.removeEventListener('auth-expired', handleAuthExpired);
    }, [disabled, location.pathname, location.search, navigate]);

    return null;
}
